module.exports = __webpack_public_path__ + "media/images/niq-warning-ae18916c40e1de4d6f64591819939e33.svg";